<script>
import { Overlay } from '../../'
export default {
    name: 'PPO', mixins: [Overlay],
    methods: {
        meta_info() { return { author: 'TradingCandle', version: '1.0.0', desc: 'Percentage Price Oscillator',
            preset: { name: 'PPO $fast $slow $signal', side: 'offchart',
                settings: { color: '#2962ff', colors: ['#2962ff', '#ef5350'], lineWidth: 1.5, skipNaN: true } } } },
        use_for() { return ['PPO'] },
        calc() { return {
            props: { fast: { def: 12, text: 'Fast', min: 1, step: 1 }, slow: { def: 26, text: 'Slow', min: 1, step: 1 }, signal: { def: 9, text: 'Signal', min: 1, step: 1 } },
            conf: { renderer: 'Splines' },
            update: `let fastAverage = ema(close, fast), slowAverage = ema(close, slow)
                    let oscillator = ts(slowAverage[0] ? 100 * (fastAverage[0] / slowAverage[0] - 1) : NaN)
                    let signalLine = ema(oscillator, signal)
                    return [oscillator[0], signalLine[0]]`
        } },
    },
}
</script>
